import { v4 as uuidv4 } from 'uuid';

interface RatingArgs {
  uuid?: string;
}

export default class Rating {
  UUID: string;

  // optional parameter uuid, new one generated if it's left off
  constructor(args: RatingArgs = {}) {
    this.UUID = args.uuid ? args.uuid : uuidv4();
  }
}
